/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useEffect, useState, useCallback } from 'react';
import Pagination from '../../../components/Pagination';
import 'tw-elements';
import { useLocation, useSearchParams } from 'react-router-dom';
import ItemShimmer from '../../../components/Shimmer/itemShimmer';
import { useDispatch, useSelector } from 'react-redux';
import { CognitoData } from '../../../CommonMethods/CognitoData';
import CardHeader from '../../../components/CardHeader';
import { CollectFeeList } from './collectfeeSlice';
import Table from './Componets/Table';
import TopBarWithShadow from '../../../components/TopBar/TopBarWithShadow';
import Debounce from '../../../CommonMethods/Debounce';
import { GetBranchId } from '../../../CommonMethods/GetBranchId';
const ManageGroupsLedgers = () => {
    const dispatch = useDispatch();
    const CollectFeeData = useSelector(state => state.CollectFeeList);
    const { List} = CollectFeeData;
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const [searchParams, setSearchParams] = useSearchParams({});
    const [email, setemail] = useState('')
    const [fistLoading, setFirstLoading] = useState(true)
    const [emptyScreenMessage, setEmptyScreenMessage] = useState('');
    
    /**
     * The function sets the loading state to true and updates the search parameters with a page number
     * of 1.
     */
    const handleLoadData = () => {
        setLoading(true);
        setSearchParams({ page_number:  1 })
    }
    /* `const getBranch` is a function that is defined using the `useCallback` hook. It is used
    to fetch the list of admin users from the server and update the state with the response data.
    The function uses the `dispatch` function from the `useDispatch` hook to dispatch an action
    creator called `AdminUser` with the `searchParams` as an argument. The `AdminUser` action
    creator is responsible for making an API call to fetch the list of admin users from the server.
    Once the API call is successful, the function checks if the `success_status` property of the
    response data is true. If it is true, the function does nothing. If it is false, the function
    sets an error message using the `setToastErrorMessage` function. The `getBranch` function
    is memoized using the `useCallback` hook with the `location` value as a dependency, which means
    that it will only be redefined if the `location` value changes. */
    const getBranch = useCallback(async () => {
        try {
            setLoading(true)
            const branch_id = await GetBranchId()
            dispatch(CollectFeeList(`collect-fees?branch_id=${branch_id}&${searchParams.toString() === "" ? 'page_number=1' :(searchParams.toString())}`)).then((response) => {
                if (response?.payload?.data.status===200) {
                    if(response.payload.data.data.data?.length === 0 && searchParams.get('search')===null && response?.payload?.data?.data.total_count === 0) {
                        setFirstLoading(true);
                    } else {
                        setEmptyScreenMessage("No matching records found.");
                        setFirstLoading(false)
                    }
                    if(Math.ceil(response?.payload?.data?.data.total_count / 10) <  Number(searchParams.get('page_number'))) {
                        if(response?.payload?.data?.data.total_count !== 0) {
                            // setToastErrorMessage('Something went wrong. Please try again')
                            setEmptyScreenMessage("No data found");
                        } else {
                            setEmptyScreenMessage("No matching records found.")
                        }
                        setLoading(false);
                    } else {
                        setLoading(false);
                    }
                } else {
                    setEmptyScreenMessage("No data found");
                    setLoading(false);

                    // setToastErrorMessage('Something went wrong. Please try again')
                }
            })
            if(email===''){
                setemail(localStorage.getItem('email'))
            }
            // setsearchFieldDebounce(searchParams.get('search') !== null ? searchParams.get('search') : '')
        } catch (error) {
            handleLoadData()
            setEmptyScreenMessage("No data found");
            console.error(error);
        }
    }, [location]);

    
    /**
     * This function handles the click event of a page number and updates the search parameters with
     * the selected page number.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    /**
     * This function updates search parameters with a new key-value pair and sets the page number to 1.
     */
    const handleSearchParams = (key, value) => {
        // setLoading(true);
        // setEmptyScreenMessage("It seems there's nothing to display here.")
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }
    const [searchValue, setSearchValue] = useState("")


    /* `useEffect(() => { getBranch(); }, [getBranch]);` is a hook that is used to run
    the `getBranch` function whenever the `getBranch` function changes. In this case,
    the `getBranch` function is memoized using the `useCallback` hook, which means that it
    will only be redefined if the `location` value changes. Therefore, the `useEffect` hook will run
    the `getBranch` function whenever the `location` value changes. This hook is used to
    fetch the list of admin users from the server and update the `tableData` state with the response
    data. */
    useEffect(() => {
        getBranch();
        if(searchParams.get("search")) {
            setSearchValue(decodeURIComponent(searchParams.get("search")))
        }
    }, [searchParams]);
 
    /* The above code is using the `useCallback` hook in React to create a memoized version of the
    `Debounce` function. The `Debounce` function is a utility function that delays the execution of
    a given function until a certain amount of time has passed without any further calls to the
    function. */
    const optimizedFn = useCallback(
        Debounce((value) => handleSearchParams('search', value)),
        [searchParams]
    );

    /**
     * The handleSearchValue function updates the search value and calls an optimized function with the
     * new value.
     */
    const handleSearchValue = (key, value) => {
        setSearchValue(value)
        optimizedFn(value)
    }
    return (
        <>
            <CardHeader noPadding>
                <TopBarWithShadow
                    SearchInput={true}
                    Tittle={"Collect Fee"}
                    SearchValue={searchValue}
                    handleOnClickSearch={handleSearchValue}
                    searchParams={searchParams}
                    customSearchPlaceHolder={`Student Name / ID`}
                />
                <div className='mainDataCntnrListDiv scrollBlue_thick'>
                    {loading ? <ItemShimmer />
                        : (
                            <>
                                <Table
                                    pageNumber={Number(searchParams.get('page_number')) || 1}
                                    setLoading={setLoading}
                                    searchParams={searchParams}
                                />
                                {(List.total_count > 10) && <Pagination
                                    TotalCount={List.total_count}
                                    totalPageNumber={Math.ceil(List.total_count / 10)}
                                    selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                                    handleOnClickPageNumber={handleOnClickPageNumber}
                                />}
                            </>
                        )
                    }
                </div>
            </CardHeader>
        </>
    );
}

export default ManageGroupsLedgers;
